<template>
  <div class="home">
    <header class="position-sticky bg-white d-flex align-items-center">
      <img src="../assets/images/logo.png" class="logo" alt="Film i Väst">
    </header>

    <main class="container my-5 flex-grow-1">
      <div class="row" :key="live">
        <div class="col-12">
          <h2 class="text-filmivast mb-0">Film i Väst Talks: Talang</h2>
          <p class="font-weight-bold">{{ $DateTime.fromISO(eventStart, { locale: "sv-SE" }).toFormat("EEEE, dd MMMM, yyyy Kl HH:mm") }}–{{ $DateTime.fromISO(eventEnd, { locale: "sv-SE" }).toFormat("HH:mm") }}</p>
        </div>

        <div class="col-12" v-if="live">
          <div class="embed-responsive embed-responsive-16by9 border">
            <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
              <jwplayer></jwplayer>
            </div>
          </div>
        </div>

        <div class="col-12" v-else-if="!live">
          <div class="embed-responsive embed-responsive-16by9">
            <div class="embed-responsive-item bg-dark text-white d-flex align-items-center justify-content-center">
              <vue-countdown :time="time" v-if="time">
                <template slot-scope="props">
                  <div class="h4 m-0 text-center">
                    {{ props.days }} {{ props.days == 1 ? "dag" : "dagar" }},
                    {{ props.hours }} {{ props.hours == 1 ? "timme" : "timmar" }},
                    {{ props.minutes }} {{ props.minutes == 1 ? "minut" : "minuter" }},
                    {{ props.seconds }} {{ props.seconds == 1 ? "sekund" : "sekunder" }}
                  </div>
                </template>
              </vue-countdown>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12 col-lg-8 content">
          <p><b>I slutet av 2020 lanserade Svenska Filminstitutet en ny talangsatsning för att få in nya röster i den svenska filmbranschen.</b></p>
          <p>Vad menar man när man pratar om talang? Vad finns det för strategier för att utveckla och behålla talang? Vilka är utmaningarna och fördelarna att som bolag arbeta med ny talang och hur ska vi se till att säkra en mångfald av kreatörer i branschen?</p>
          <p>Film i Väst har bjudit in två producenter från olika håll för att diskutera dessa frågor med utgångspunkt i deras eget arbete med talang – <em>Magne Lyngner</em> från Bacon Productions (NO) och <em>Anna-Maria Kantarius</em> från Garagefilm (SE).</p>
          <p>Vi kommer även presentera Film i Västs talangarbete, samt avslöja två helt nya satsningar. Samtalet modereras av Jenny Luukkonen, ansvarig för talang, korta format samt dokumentärfilm.</p>
        </div>
        <div class="col-12 col-lg-4">
          <p class="font-weight-bold">Ställ gärna dina frågor här:</p>

          <form name="questionForm" @submit.prevent="sendQuestion">
            <div class="form-group">
              <label for="name">Namn / Organisation</label>
              <input type="text" name="name" id="name" v-model="questionName" class="form-control">
            </div>

            <div class="form-group">
              <label for="question">Fråga</label>
              <textarea type="text" name="question" id="question" v-model="questionQuestion" class="form-control"></textarea>
            </div>

            <div class="form-group">
              <vue-recaptcha :sitekey="recaptchaSiteKey" @verify="verifyRecaptcha"></vue-recaptcha>
            </div>

            <button type="submit" name="send" id="send" class="btn btn-sm btn-success" :disabled="!this.questionFormValid">Skicka</button>
          </form>
        </div>
      </div>
    </main>

    <footer class="text-white">
      <div class="container">
        <div class="row">
          <div class="col-12 small py-3">
            Film i Väst Talks - en del av <a href="https://filmivast.se" class="text-white">Film i Väst</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  import VueCountdown from "@chenfengyuan/vue-countdown"
  import Jwplayer from "@/components/jwplayer"
  import VueRecaptcha from "vue-recaptcha"

  export default {
    name: "home",
    components: { VueCountdown, Jwplayer, VueRecaptcha },
    data() {
      return {
        recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
        recaptchaValid: false,
        eventStart: "2021-05-19T14:00:00",
        eventEnd: "2021-05-19T14:45:00",
        eventTimezone: "Europe/Stockholm",
        time: null,
        settings: null,
        loading: false,
        questionName: null,
        questionQuestion: null
      }
    },
    computed: {
      live() {
        let testMode = new URLSearchParams(window.location.search).get("wearejaws")
        return testMode || (this.settings && this.settings.active == true)
      },
      questionFormValid() {
        return !this.loading &&
          (this.questionName && this.questionName.length > 0) &&
          (this.questionQuestion && this.questionQuestion.length > 0) &&
          (this.recaptchaValid)
      },
      eventStartObject() {
        return this.$DateTime.fromISO(this.eventStart, { zone: this.eventTimezone })
      },
      eventEndObject() {
        return this.$DateTime.fromISO(this.eventEnd, { zone: this.eventTimezone })
      }
    },
    methods: {
      verifyRecaptcha() {
        this.recaptchaValid = true
      },
      async sendQuestion() {
        if(!this.questionFormValid) { return false }
        this.loading = true

        await firebase.firestore().collection(`questions`).add({
          name: this.questionName,
          question: this.questionQuestion,
          created: firebase.firestore.FieldValue.serverTimestamp()
        })

        this.questionQuestion = null
        this.loading = false
      }
    },
    async mounted() {
      await this.$bind("settings", firebase.firestore().collection(`application`).doc(`settings`))

      let now = this.$DateTime.local().setZone(this.eventTimezone)
      let millis = this.eventStartObject.diff(now).toObject()

      if(millis.milliseconds < 0) {
        this.time = 0
      } else {
        this.time = millis.milliseconds
      }
    }
  }
</script>

<style lang="scss" scoped>
  header {
    padding: 5px 30px;
    padding-bottom: 5px;
    top: 0;
    box-shadow: rgba(0, 0, 0, .117647) 0 1px 3px;

    .logo {
      height: 55px;
    }
  }

  .content {
    line-height: 1.4;

    .content-image {
      width: 375px;
    }
  }

  footer {
    background-color: #282a2b;
  }
</style>
